import { INTERNET_EXPLORER } from '../../constants/userAgent';

export function checkInternetExplorer(userAgent: string): boolean {
  return INTERNET_EXPLORER.test(userAgent);
}
